import { useMemo } from 'react';
import type { CSSProperties } from 'react';
import { breadcrumbStyle, centerStyle, headerStyle } from './SuperHeader.styles';

export interface SuperHeaderViewModel {
  headerStyle: CSSProperties;
  breadcrumbStyle: CSSProperties;
  centerStyle: CSSProperties;
}

export function useSuperHeader(): SuperHeaderViewModel {
  return useMemo(() => ({ headerStyle, breadcrumbStyle, centerStyle }), []);
}
